import { PromiseInspection } from './promise-inspection';
export const settlePromises = promises => {
  const inspections = promises.map(PromiseInspection.create);
  const inspectedPromises = inspections.map(inspection => inspection.getPromise());
  return Promise.all(inspectedPromises).then(() => inspections);
};